module.exports = __webpack_public_path__ + "assets/add.4001720e.svg";